export default class PromoBannerL {
  constructor(data) {
    if (data && data.fields && data.sys) {
      const {
        entryTitle,
        identifier,
        slug,
        ctasTextBlock,
        image,
        tabletImage,
        mobileImage,
        video,
        mobileVideo,
        videoUrl,
        videoVttFile,
        textBlockVariant,
        isAutoplay,
        imageAboveText,
        textBoxWidth,
        eyebrowText,
        isImageTransparent,
        ctasSideBySide,
        imageCtAsSideBySide,
        imageButtons,
        textAlignment,
        ctaTextAlignment,
        ctaFullWidth,
        textVariant,
        contentTextBlock,
        isImageAboveTextTransparent,
        isTextBlockOnTheLeft,
        textBlockBackground,
        appearance,
        isAnimationEnabled,
        mobileTextPosition,
        textAlignmentVertical,
        desktopImageFocus,
        videoFocus,
        topTitleXL,
        textBoxMobileHeight,
        fixedMobileHeight,
        fixedHeight,
        backgroundStyle,
        bannerBackgroundImage,
        bannerBackgroundImageMobile,
        enhancedBannerBackground,
        backgroundGradient,
      } = data.fields;
      this.id = data.sys.id;
      this.entryTitle = entryTitle;
      this.identifier = identifier;
      this.slug = slug;
      this.isAutoplay = isAutoplay;
      this.ctasTextBlock = ctasTextBlock;
      this.image = image;
      this.tabletImage = tabletImage;
      this.mobileImage = mobileImage;
      this.video = video;
      this.mobileVideo = mobileVideo;
      this.textBlockVariant = textBlockVariant;
      this.imageAboveText = imageAboveText;
      this.textBoxWidth = textBoxWidth;
      this.eyebrowText = eyebrowText;
      this.isImageTransparent = isImageTransparent;
      this.ctasSideBySide = ctasSideBySide;
      this.imageButtons = imageButtons;
      this.textAlignment = textAlignment;
      this.ctaTextAlignment = ctaTextAlignment;
      this.ctaFullWidth = ctaFullWidth;
      this.textVariant = textVariant;
      this.contentTextBlock = contentTextBlock;
      this.imageCtAsSideBySide = imageCtAsSideBySide;
      this.isTextBlockOnTheLeft = isTextBlockOnTheLeft;
      this.isImageAboveTextTransparent = isImageAboveTextTransparent;
      this.textBlockBackground = textBlockBackground;
      this.appearance = appearance;
      this.isAnimationEnabled = isAnimationEnabled;
      this.mobileTextPosition = mobileTextPosition;
      this.textAlignmentVertical = textAlignmentVertical;
      this.desktopImageFocus = desktopImageFocus;
      this.videoUrl = videoUrl;
      this.videoVttFile = videoVttFile;
      this.videoFocus = videoFocus;
      this.topTitleXL = topTitleXL;
      this.textBoxMobileHeight = textBoxMobileHeight;
      this.fixedMobileHeight = fixedMobileHeight
        ? `${fixedMobileHeight}px`
        : null;
      this.fixedHeight = fixedHeight ? `${fixedHeight}px` : null;
      this.backgroundStyle = backgroundStyle;
      this.bannerBackgroundImage = bannerBackgroundImage;
      this.bannerBackgroundImageMobile = bannerBackgroundImageMobile;
      this.enhancedBannerBackground = enhancedBannerBackground;
      this.backgroundGradient = backgroundGradient;
    }
  }
}
